"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fieldType_1 = __importDefault(require("../fieldType"));
const isString_1 = __importDefault(require("lodash/isString"));
const Errors_1 = __importDefault(require("../Errors"));
exports.default = (0, fieldType_1.default)({
    name: 'email',
    validate(value) {
        if (!(0, isString_1.default)(value))
            return Errors_1.default.NOT_A_STRING;
        // eslint-disable-next-line
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regex.test(value))
            return Errors_1.default.NOT_AN_EMAIL;
    },
    clean(value) {
        if (typeof value === 'string') {
            value = value.toLowerCase();
        }
        return value;
    }
});
